
<template>
   <v-layout row wrap>
      <v-flex xs12>
         <v-card>
            <v-list two-line>
               <v-btn fab small color="yellow" top right absolute
                  v-if="mode === 'caregiver'"
                  @click="openAddDialog()">
                  <v-icon>add</v-icon>
               </v-btn>

               <template v-for="(userSurvey, index) in userSurveys">
                  <v-list-tile avatar ripple @click="selectUserSurvey(userSurvey.id)" :key="userSurvey.id"
                               v-bind:class="{ 'red': userSurvey.id == selectedUserSurveyId, 'lighten-4': userSurvey.id == selectedUserSurveyId }">
                     <v-list-tile-action>
                        <v-icon color="green darken-1">{{ isComplete(userSurvey) ? 'check_circle' : 'more_horiz' }}</v-icon>
                     </v-list-tile-action>
                     <v-list-tile-content>
                        <v-list-tile-title>{{ surveyName(userSurvey) }}</v-list-tile-title>
                        <v-list-tile-sub-title v-if="!isComplete(userSurvey)" color="red">À compléter ({{ answerCount(userSurvey) }}/ {{ questionCount(userSurvey) }})</v-list-tile-sub-title>
                     </v-list-tile-content>
                     <v-list-tile-action>
                        <v-btn icon ripple @click.stop="userSurveyToDelete = clone(userSurvey); deleteDialog = true">
                           <v-icon color="grey lighten-1">delete</v-icon>
                        </v-btn>
                     </v-list-tile-action>
                  </v-list-tile>
                  <v-divider v-if="index + 1 < userSurveys.length" :key="userSurvey.id + '-'"></v-divider>
               </template>
            </v-list>

            <v-card-text v-if="userSurveys.length === 0" style="height: 100px;" class="Aligner">
               <v-icon>not_interested</v-icon>
            </v-card-text>
         </v-card>
      </v-flex>

      <v-dialog v-model="addDialog" persistent max-width="400">
         <v-card>
            <v-card-title class="headline grey lighten-2">Assigner des questionnaires</v-card-title>
            <v-card-text>
               <v-radio-group v-model="choice">
                  <div v-for="(survey, index) in surveys">
                     <!--v-checkbox
                        v-model="choosenSurveyIndexes[index]"
                        :key="index"
                        :label="survey.name"
                     ></v-checkbox-->
                     <v-radio
                        :key="index"
                        :label="survey.name"
                        :value="survey"
                     ></v-radio>
                  </div>
               </v-radio-group>
            </v-card-text>
            <v-card-actions>
               <v-spacer></v-spacer>
               <v-btn color="brown darken-2" flat @click.native="addDialog = false; assignSurveys()">Assigner</v-btn>
               <v-btn color="brown darken-2" flat @click.native="addDialog = false">Annuler</v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>

      <v-dialog v-model="deleteDialog" persistent max-width="400">
         <v-card>
            <v-card-title class="headline grey lighten-2">Confirmer</v-card-title>
            <v-card-text>Supprimer {{ userSurveyToDelete.name }} ?</v-card-text>
            <v-card-actions>
               <v-spacer></v-spacer>
               <v-btn color="brown darken-2" flat @click.native="deleteDialog = false; deleteUserSurvey(userSurveyToDelete)">Supprimer</v-btn>
               <v-btn color="brown darken-2" flat @click.native="deleteDialog = false">Annuler</v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>

   </v-layout>
</template>


<script>
   import _ from 'lodash'

   export default {

      props: {
         title: String,
         userId: Number,
         selectedUserSurveyId: Number,
         mode: String, // 'patient', 'caregiver'
      },

      data () {
         return {
            addDialog: false,
            deleteDialog: false,
            userSurveyToDelete: {},
            choice: null,
         }
      },

      computed: {
         surveys () {
            return this.$store.state.surveys.surveyList.map(surveyId => this.$store.state.surveys.surveys[surveyId])
         },
         userSurveys() {
            return this.$store.getters['surveys/userSurveys'](this.userId)
         },
      },

      methods: {
         clone (userSurvey) {
            return _.clone(userSurvey)
         },
         selectUserSurvey (userSurveyId) {
            this.$emit('userSurveySelected', userSurveyId)
         },
         openAddDialog: function() {
            this.choice = null
            this.addDialog = true
         },
         assignSurveys () {
            this.$emit('addUserSurvey', this.choice.id)
         },
         deleteUserSurvey (userSurvey) {
            this.$emit('deleteUserSurvey', userSurvey)
         },
         surveyName: function(userSurvey) {
            let survey = this.$store.state.surveys.surveys[userSurvey.survey]
            return survey.name
         },
         answerCount: function(userSurvey) {
            let answerCount = userSurvey.answers.reduce(function(accu, answer) {
               if (answer === null) {
                  return accu
               } else {
                  return accu + 1
               }
            }, 0)
            return answerCount
         },
         questionCount: function(userSurvey) {
            let survey = this.$store.state.surveys.surveys[userSurvey.survey]
            return survey.params.questions.length
         },
         isComplete: function(userSurvey) {
            let survey = this.$store.state.surveys.surveys[userSurvey.survey]
            return survey.params.questions.length === this.answerCount(userSurvey)
         },
      },
   };
</script>

<style scoped>
</style


// WEBPACK FOOTER //
// UserSurveyList.vue?f2b62f4e